module.exports = __webpack_public_path__ + "media/index/today-67eb4352.svg";